export const INDEXED_DB_CONFIG = {
  version: 9,
  dbName: 'mobitech_db',
  stores: {
    user: '@user-data-store',
    planning: '@order-planning-store',
    planningDetail: '@order-planning-detail-store',
    template: '@download-template-store',
    masterLocation: '@master-location-store',
    orderCreateBulk: '@order-create-bulk-store',
  },
};

export const USER_ROLES_STORE = '@user-roles-store';
export const THEME_STORE = '@theme-store';
